import { render, staticRenderFns } from "./SaveIndicator.vue?vue&type=template&id=57554f16&scoped=true&"
import script from "./SaveIndicator.vue?vue&type=script&lang=ts&"
export * from "./SaveIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./SaveIndicator.vue?vue&type=style&index=0&id=57554f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57554f16",
  null
  
)

export default component.exports